export default __webpack_public_path__ + "static/media/inflatables.1b640fec.svg";